/**
 * 指定名のcookieを取得
 */
export default name => {
  let result = null
  const cookieName = name + '='
  const allcookies = document.cookie
  const position = allcookies.indexOf(cookieName)
  if (position !== -1) {
    const startIndex = position + cookieName.length
    let endIndex = allcookies.indexOf(' ', startIndex)
    if (endIndex === -1) {
      endIndex = allcookies.length
    }
    result = decodeURIComponent(allcookies.substring(startIndex, endIndex)).replace(';', '')
  }
  return result
}
